import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FileService } from "src/app/services/file/file.service";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { ProductModel } from "../../shared/models/brands";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
})
export class ProductsComponent implements OnInit {
  products: ProductModel[];
  tempOptionModel: any;
  getAllCategories: any = [];
  ProductsListHeaders: any;
  excelFileName: string = null;
  filteredDetails: any = {
    search_string: "",
    category: [],
    sku: "",
  };
  filteredDetailsForApi: any = {
    search_string: "",
    category: "",
    sku: "",
  };
  getPaginationCount = 0;
  page = 1;
  constructor(
    private router: Router,
    private service: ApiService,
    private config: ApiConfiguration,
    private toast: ToastClientService,
    private modalService: NgbModal,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    public fileService: FileService,
    private uploadFile: UploadZipService,
    public adminDataProvider: AdminDataProvider,
    public alertService: AlertService
  ) {}

  ngOnInit() {
    this.getProductsList(this.filteredDetailsForApi);
    this.getAllCategory();
  }

  editProduct(product) {
    this.router.navigateByUrl("/hubAdmin/product-edit/" + product.product_id);
  }

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  getExcelBrandsFields() {
    this.service.get(this.config.productUploadExcelFields).subscribe(
      (res: any) => {
        if (res.data) {
          let headers = Object.keys(res.data.product_fields);
          this.ProductsListHeaders = headers;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  getAllCategory() {
    this.service.getHeaders(this.config.getAllCategiry).subscribe(
      (res: any) => {
        if (res.data) {
          this.getAllCategories = res.body.data;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  downloadFile() {
    //this.exportExcelService.exportBrandExcel(this.ProductsListHeaders,'Add_Products_',this.getAllCategoryAndSubCategory);
  }
  uploadXlsx(eve) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        if (result) {
          this.uploadMultiData(result);
        }
      },
      (reason) => {}
    );
  }

  uploadMultiData(data) {
    this.enableUploadDiv(data);
  }
  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.config.uploadMultiProducts,
      module: "Products",
      excelname: this.excelFileName,
    });
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // State
        this.filteredDetails.category = await data;
      default:
        break;
    }
  }
  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1);
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach((element) => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }
  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.filteredDetailsForApi.sku = this.filteredDetails.sku;
      this.filteredDetailsForApi.category = this.filteredDetails.category
        .map((i) => i.id)
        .join(",")
        .toString();
    } catch (error) {}
    console.log(this.filteredDetailsForApi);
    this.getProductsList(this.filteredDetailsForApi);
  }
  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getProductsList(this.filteredDetailsForApi);
  }
  getProductsList(data) {
    this.service
      .getHeaders(
        this.config.getProductsList +
          "?page=" +
          this.page +
          "&search_string=" +
          data.search_string +
          "&category_id=" +
          data.category +
          "&product_code=" +
          data.sku
      )
      .subscribe((res: any) => {
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        this.products = res.body.data as ProductModel[];
        if (this.products.length > 0) {
          this.products.forEach((c) => {
            c.statusString = c.status == 1 ? "Active" : "Inactive";
            c.show = c.status == 1 ? true : false;
          });
        }
      });
  }

  changeLoyalty(item) {
    item.is_loyalty = item.is_loyalty == false ? 0 : 1;
    this.service
      .put(this.config.updateProduct + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.getProductsList(this.filteredDetailsForApi);
        this.alertService.success(res.body.data.message);
        this.clearSuccess();
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
